/**
* DevExpress Dashboard (_group-item.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { RenderHelper } from '../widgets/_render-helper';
import { baseItem, cssClassNamesBaseItem } from './_base-item';
export class groupItem extends baseItem {
    constructor(container, options) {
        super(container, options);
    }
    renderContentUnsafe(element, changeExisting, afterRenderCallback) {
        element.classList.add(cssClassNamesBaseItem.groupItem);
        return false;
    }
    _itemHasOwnContent() {
        return false;
    }
    _toggleLoadingPanel() {
    }
    getOffset() {
        var borderSize = RenderHelper.getBorderSizeByClasses([cssClassNamesBaseItem.groupItem]);
        return {
            width: borderSize.width,
            height: borderSize.height + this._calcHeaderAndFooterHeight()
        };
    }
}
